import React, { createContext, useContext, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { toJS } from "mobx";
import moment from "moment";
import RequestStore from "../approvals/store/requeststore";
import NaocDailyProductionStore from "../store/naocdailyproductionstore";
import MainStore from "../../home/store/mainStore";
import { observer } from "mobx-react-lite";
import { CommandBar, SearchBox } from "@fluentui/react";
import { ExternalLink } from "react-feather";
import { Badge, Button, notification } from "antd";
import { FileExcelOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { CommentPane } from "./CommentPane";
import { MessageBar, MessageBarType } from "@fluentui/react";
import ReportStore from "../../../shared/ReportStore";
import EbendoDailyProductionStore from "../store/ebendodailyproductionstore";
import QuaiboDailyProductionStore from "../store/quaibodailyproductionstore";
import _ from "underscore";
const requestStoreCtx = createContext(RequestStore);
const reportStoreCtx = createContext(ReportStore);
const mainStorectx = createContext(MainStore);
const EbendoStoreCtx = createContext(EbendoDailyProductionStore);
const QuaiboStoreCtx = createContext(QuaiboDailyProductionStore);
export const ApprovalGrid = observer(() => {
  const requestStore = useContext(requestStoreCtx);
  const naocDailyProductionStore = useContext(NaocDailyProductionStore);
  const ebendoDailyProductionStore = useContext(EbendoStoreCtx);
  const quaiboDailyProductionStore = useContext(QuaiboStoreCtx);
  const reportStore = useContext(reportStoreCtx);
  const mainStore = useContext(mainStorectx);
  const onReady = (grid) => {
    requestStore.reqGrid = grid;
    // grid.api.setQuickFilter("Awaiting Approval");
  };
  const rowSelected = (grid) => {
    const selrow = grid.api.getSelectedNodes()[0];

    if (selrow) {
      requestStore.selAppItem = toJS(selrow.data);
      console.log("selapp", selrow.data);
    } else {
      requestStore.selAppItem = {};
    }
    requestStore.selAppItems = _.map(
      _.pluck(grid.api.getSelectedNodes(), "data"),
      (x) => toJS(x)
    );
    console.log("selAppItems", requestStore.selAppItems);
  };
  const reqGrid = useRef(null);
  const gridcolumnDefs = {
    columnDefs: [
      {
        headerName: "#",
        valueGetter: "node.rowIndex + 1",
        width: 50,
        resizable: true,
        sortable: true,
        pivot: false,
      },
      {
        rowDrag: true,

        width: 80,
        checkboxSelection: true,
        pivot: false,
      },
      {
        headerName: "Request",
        field: "productionDate",
        sortable: true,
        resizable: true,
        pivot: true,
        cellRendererFramework: (item) => {
          if (!item.data) {
            return null;
          }

          return (
            <>
              <Button
                type="link"
                size="small"
                title="show production entry details"
                onClick={async () => {
                  try {
                    if (mainStore.assetContextId === 1) {
                      requestStore.showNaocProductionDetailDialog = true;
                      naocDailyProductionStore.IsEquityProduction = 0;
                      await naocDailyProductionStore.getNaocDailProductionById(
                        item.data.productionId
                      );
                    } else if (mainStore.assetContextId === 2) {
                      requestStore.showEbendoProductionDetailDialog = true;
                      await ebendoDailyProductionStore.getEbendoDailyProductionById(
                        item.data.productionId
                      );
                    } else if (mainStore.assetContextId === 3) {
                      requestStore.showQuaiboProductionDetailDialog = true;
                      await quaiboDailyProductionStore.getQuaiboDailProductionById(
                        item.data.productionId
                      );
                    }
                  } catch (error) {
                    notification.error({
                      message: "SPARS Feedback",
                      description: error.message,
                    });
                  }

                  //requestStore.showCommentPane = true;
                }}
                style={{ cursor: "pointer" }}
                icon={
                  <ExternalLink
                    size={16}
                    color="gray"
                    style={{ marginRight: "5px" }}
                  />
                }
              >
                {" "}
                <span style={{ fontSize: "12px" }}>
                  {`  ${moment(item.data?.productionDate).format(
                    "DD.MMM.YYYY"
                  )}-PESR`}{" "}
                </span>
              </Button>
            </>
          );
        },
      },

      {
        headerName: "OER",
        field: "productionDate",
        sortable: true,
        width: 150,
        resizable: true,
        pivot: true,
        cellRendererFramework: (item) => {
          if (!item.data) {
            return null;
          }

          return (
            <div
              title={`click to dispaly OER Provisional ${mainStore.assetContextName} JV Daily Production Report`}
            >
              <Button
                size="small"
                type="link"
                onClick={async () => {
                  try {
                    let reportDate = null;
                    if (item.data?.productionDate) {
                      reportDate = moment(item.data?.productionDate).add(
                        1,
                        "days"
                      );
                      console.log(reportDate);
                    }

                    reportStore.reportParameters = {
                      ProdDate: reportDate,
                      PreparedBy: item.data.requestor,
                    };
                    if (mainStore.assetContextId === 1) {
                      reportStore.reportName =
                        "QikReach.Reporting.Naoc.OERReport,QikReach.Reporting";
                      reportStore.headerText =
                        "OER Provisional NAOC JV Daily Production";
                    } else if (mainStore.assetContextId === 2) {
                      reportStore.reportName =
                        "QikReach.Reporting.Ebendo.EbendoOERReport,QikReach.Reporting";
                      reportStore.headerText =
                        "OER Provisional EBENDO JV Daily Production";
                    } else if (mainStore.assetContextId === 3) {
                      reportStore.reportName =
                        "QikReach.Reporting.Quaibo.QuaiboOERReport,QikReach.Reporting";
                      reportStore.headerText =
                        "OER Provisional QUAIBO JV Daily Production";
                    }

                    reportStore.showReportDialog = true;
                  } catch (error) {
                    notification.error({
                      message: "SPARS Feedback",
                      description: error.message,
                    });
                  }

                  //requestStore.showCommentPane = true;
                }}
                style={{ cursor: "pointer" }}
              >
                {" "}
                <span style={{ fontSize: "12px" }}>QC OER Report</span>
              </Button>
            </div>
          );
        },
      },

      {
        headerName: "Requestor Comment",
        field: "requestorComment",
        sortable: true,
        resizable: true,
        pivot: true,
        cellRendererFramework: (item) => {
          if (!item.data) {
            return null;
          }

          return (
            item.data.requestorComment && (
              <>
                <span>
                  {" "}
                  <Button
                    type="link"
                    title="show requestor comment"
                    onClick={() => {
                      console.log("clicked");
                      requestStore.reqObj = {
                        title: ` ${moment(item.data?.productionDate).format(
                          "ddd MMMM D,YYYY"
                        )} requestor comment`,
                        comment: item.data.requestorComment,
                      };
                      requestStore.showCommentPane = true;
                    }}
                    style={{ cursor: "pointer" }}
                    icon={<ExternalLink size={16} color="gray" />}
                  ></Button>
                </span>
                <span>{item.data.requestorComment}</span>
              </>
            )
          );
        },
      },
      {
        headerName: "Status",
        field: "status",
        sortable: true,
        resizable: true,
        pivot: true,
        cellRendererFramework: (item) => {
          const antStatuses = ["default", "warning", "success", "error"];
          const submitStatuses = [
            "Not Submitted",
            "Awaiting Approval",
            "Approved",
            "Declined",
          ];
          return (
            <div
              style={{ padding: "none!important" }}
              title={submitStatuses[item.data.approvalStatus]}
            >
              <Badge status={antStatuses[item.data.approvalStatus]} />{" "}
              {item.data.status}
            </div>
          );
        },
      },
      {
        headerName: "Audit",
        children: [
          {
            headerName: "Requestor Party",
            field: "requestor",
            sortable: true,
            resizable: true,
            pivot: true,
            cellRendererFramework: (item) => {
              return item.data.requestor.replace("<br/>", "-");
            },
          },
          {
            headerName: "Request Date",
            field: "requestDate",
            sortable: true,
            resizable: true,
            type: "dateColumn",
            pivot: true,
            cellRendererFramework: (item) => {
              return (
                <span title={moment(item.data.requestDate).format("LLLL")}>
                  {moment(item.data.requestDate).fromNow()}
                </span>
              );
            },
          },
          {
            headerName: "Approver party",
            field: "approver",
            sortable: true,
            resizable: true,
            pivot: true,
            cellRendererFramework: (item) => {
              return item.data.approver.replace("<br/>", "-");
            },
          },
          {
            headerName: "Approved/Declined Date",
            field: "approvedDate",
            sortable: true,
            resizable: true,
            pivot: true,
            type: "dateColumn",
            cellRendererFramework: (item) => {
              if (item.data.approvedDate) {
                return (
                  <span title={moment(item.data.approvedDate).format("LLLL")}>
                    {moment(item.data.approvedDate).fromNow()}
                  </span>
                );
              } else {
                return null;
              }
            },
          },
          {
            headerName: "Approver Remarks",
            field: "approverComment",
            sortable: true,
            resizable: true,
            pivot: true,
            cellRendererFramework: (item) => {
              if (!item.data) {
                return null;
              }

              return (
                item.data.approverComment && (
                  <>
                    <span>
                      {" "}
                      <Button
                        type="link"
                        title="show approver remarks"
                        onClick={() => {
                          //console.log("clicked");
                          requestStore.reqObj = {
                            title: ` ${moment(item.data?.productionDate).format(
                              "ddd MMMM D,YYYY"
                            )} approver remarks`,
                            comment: item.data.approverComment,
                          };
                          requestStore.showCommentPane = true;
                        }}
                        style={{ cursor: "pointer" }}
                        icon={<ExternalLink size={16} color="gray" />}
                      ></Button>
                    </span>
                    <span>{item.data.approverComment}</span>
                  </>
                )
              );
            },
          },
        ],
      },
    ],
  };
  return (
    <>
      <CommandBar
        items={[
          {
            key: "spacer3",
            onRender: () => <div style={{ width: "600px" }} />,
          },
          {
            key: "search",
            onRender: () => (
              <Tooltip title="smart quick search on the requests data displayed">
                <SearchBox
                  placeholder="Search"
                  styles={{
                    root: {
                      width: "100%",
                      borderBottomColor: "#CBD5E0",
                    },
                  }}
                  underlined={true}
                  onChange={(ev, searchTerms) => {
                    reqGrid.current.api.setQuickFilter(searchTerms);
                    // const filterValue = grid.current.api.filterManager.quickFilter;
                  }}
                ></SearchBox>
              </Tooltip>
            ),
          },
        ]}
        farItems={[
          {
            key: "group4",

            text: (
              <Tooltip title="Export displayed production data to excel">
                Export to Excel
              </Tooltip>
            ),
            name: "group",
            onRenderIcon: () => <FileExcelOutlined className="qicon" />,

            onClick: async () => {
              try {
                await reqGrid.current.api.exportDataAsExcel({
                  sheetName: "my requests",

                  allColumns: true,

                  skipFooters: false,
                  skipGroups: false,
                  skipHeader: false,
                  skipPinnedTop: false,
                  skipPinnedBottom: false,
                  fileName: "request_wokflow_data",
                  skipColumnGroupHeaders: false,
                  skipColumnHeaders: false,
                  columnGroups: true,
                });
              } catch (error) {
                notification.error({
                  message: "SPARS Feedback",
                  description: "export failed",
                });
              } finally {
              }
            },
          },
        ]}
      />
      <div className="ms-Grid-col ms-sm12">
        <MessageBar messageBarType={MessageBarType.warning}>
          click any row or ctrl+click to select multiple rows for production
          sign-off.
        </MessageBar>
      </div>
      <div
        className="ag-theme-balham"
        style={{
          minHeight: "50vh",
          height: "65vh",
          width: "100%",
          maxHeight: "80vh",
          paddingTop: "10px",
        }}
      >
        <AgGridReact
          rowData={[...requestStore.myApprovals.values()].map((x) => toJS(x))}
          sideBar={["columns", "filters"]}
          ref={reqGrid}
          onReady={onReady}
          gridOptions={{
            defaultColDef: {
              sortable: true,
              filter: true,
              enableValue: true,
              enableRowGroup: true,
              enablePivot: true,
            },
            enableCharts: true,
            enableRangeSelection: true,

            pagination: true,
            columnDefs: gridcolumnDefs.columnDefs,
            animateRows: true,
            statusBar: {
              statusPanels: [
                {
                  statusPanel: "agTotalRowCountComponent",
                  align: "center",
                },
              ],
            },
            columnTypes: {
              numberColumn: {
                width: 130,
                filter: "agNumberColumnFilter",
              },
              medalColumn: {
                width: 100,
                columnGroupShow: "open",
                filter: false,
              },
              nonEditableColumn: { editable: false },
              dateColumn: {
                filter: "agDateColumnFilter",
                filterParams: {
                  comparator: function (filterLocalDateAtMidnight, cellValue) {
                    var dateParts = cellValue.split("/");
                    var day = Number(dateParts[0]);
                    var month = Number(dateParts[1]) - 1;
                    var year = Number(dateParts[2]);
                    var cellDate = new Date(year, month, day);
                    if (cellDate < filterLocalDateAtMidnight) {
                      return -1;
                    } else if (cellDate > filterLocalDateAtMidnight) {
                      return 1;
                    } else {
                      return 0;
                    }
                  },
                },
              },
            },
          }}
          rowSelection="multiple"
          rowMultiSelectWithClick={true}
          onSelectionChanged={rowSelected}
          onGridReady={onReady}
          copyHeadersToClipboard={true}
          overlayLoadingTemplate={`${(
            <span class="ag-overlay-loading-center">
              Please wait while your rows are loading
            </span>
          )}`}
          overlayNoRowsTemplate={
            '<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;">No Result</span>'
          }
        ></AgGridReact>
      </div>
      <CommentPane />
    </>
  );
});

